import { IClothData, IClothItemData } from "@biz/logic/ClothData";

export function getClothColorReducers<T extends IClothItemData>() {
  return {
    setClothAndColor(old: T, cloth: IClothData | undefined, colorId: string): T {
      return { ...old, cloth, colorId, }
    },
  }
}